const staffRoles = ['admin', 'manager', 'coach'];

const userHasStaffRole = (userRoles) => {
  return userRoles.some((r) => staffRoles.includes(r));
};

export default userHasStaffRole;
